import classNames from "classnames";
import PropTypes from "prop-types";
import { memo, useState } from "react";

import classes from "./Input.module.scss";

function Inp({
  className,
  onBlur,
  type,
  onChange,
  name,
  placeholder,
  value,
  hasSearchIcon,
  error,
  touched,
  isSearchSubmit,
  isHiddenInput,
  isRefreshButton,
  subErrorClass,
  isDisableInput,
  inputRef,
  ...restProps
}) {
  const [isHidden, setIsHidden] = useState(isHiddenInput);

  function toggleVisible() {
    setIsHidden((o) => !o);
  }

  function handleKeyPress(event) {
    if (type === "email") {
      const pattern = /^[a-zA-Z0-9@.\-_]+$/;
      if (!pattern.test(event.key) && event.key != 'Backspace') {
        event.preventDefault();
      }
    }
  }

  return (
    <div className={classes.inputContainer}>
      <div className={isDisableInput ? "disabledClassShadow" : ""}>
        <input
          autoComplete="off"
          className={classNames(
            classes.input,
            className,
            "inputClass form-control font-20 font-sm-16",
            {
              [classes.searchIconInputClass]:
                hasSearchIcon && !isSearchSubmit && !isHiddenInput,
            },
            isDisableInput ? "disabledInput" : "",
            isHiddenInput ? classes.inputPadding : ""
          )}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder}
          type={isHidden ? "password" : "text"}
          value={value}
          ref={inputRef}
          {...restProps}
        />
      </div>
      {isHiddenInput ? (
        <button
          className={classNames(
            "btnLink font-20 font-sm-14",
            classes.inputHide
          )}
          onClick={toggleVisible}
          type="button"
        >
          {isHidden ? "SHOW" : "HIDE"}
        </button>
      ) : null}
      {!isHiddenInput && isSearchSubmit ? (
        <button className="submitSearchButton" disabled={!value} type="submit">
          <img alt="search" src="/servicing/images/search.svg" />
        </button>
      ) : null}
      {touched && error ? (
        <span
          className={`inputErrorText font-14 font-sm-12 ${subErrorClass} ${
            isRefreshButton ? "position-absolute mt-2" : ""
          }`}
        >
          {error}
        </span>
      ) : null}
    </div>
  );
}

Inp.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  hasSearchIcon: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  isDisableInput: PropTypes.bool,
  isHiddenInput: PropTypes.bool,
  isRefreshButton: PropTypes.bool,
  isSearchSubmit: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  subErrorClass: PropTypes.string,
  touched: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
};

Inp.defaultProps = {
  className: "",
  error: "",
  hasSearchIcon: false,
  isDisableInput: false,
  isHiddenInput: false,
  isRefreshButton: false,
  isSearchSubmit: false,
  onBlur: () => {},
  placeholder: "Start Typing here",
  subErrorClass: "",
  touched: false,
  type: "text",
  value: "",
};

export default memo(Inp);
